import { useDebounceCallback } from "usehooks-ts";
import Input from "@/components/ui/input";
import { Spinner } from "@/shared";
import { cn } from "@lib/cn";
import { IconSearch } from "@tabler/icons-react";
import { useSlidesLibraryStoreShallow } from "../store";

export const SlidesLibrarySearch = ({ fullWidth = false }: { fullWidth?: boolean }) => {
  const { setSearch, isSearching } = useSlidesLibraryStoreShallow((s) => ({
    setSearch: s.setSearch,
    isSearching: s.isSearching,
  }));
  const handleSearchChange = useDebounceCallback(setSearch, 300);

  return (
    <div className={cn("tw-relative", fullWidth && "tw-w-full")}>
      <IconSearch
        size={16}
        stroke={1.5}
        className="tw-absolute tw-left-3 tw-top-1/2 tw-z-1 -tw-translate-y-1/2 tw-text-blue-500"
      />
      <Input
        placeholder="Search"
        size="sm"
        className={cn("tw-rounded-lg tw-pl-9 tw-pr-6 !tw-text-sm", fullWidth ? "tw-w-full" : "tw-w-60")}
        onChange={(e) => {
          const value = e.target.value;
          handleSearchChange(value);
        }}
      />
      {isSearching && (
        <span className="tw-absolute tw-right-3 tw-top-1/2 tw-z-1 -tw-translate-y-1/2">
          <Spinner className="tw-block tw-size-3" />
        </span>
      )}
    </div>
  );
};
